// Chart tokens. Brand palette (oxblood/gold/blush) carries chrome; series
// identity uses the data-viz skill's pre-validated categorical palette
// (CVD ΔE 24.2 > 12). Contrast WARN on aqua/yellow/magenta is covered by the
// legend + the always-present table view in the comparison explorer.

// Fixed categorical order — assigned by first appearance, never cycled.
export const CATEGORICAL = [
  '#2a78d6', '#1baf7a', '#eda100', '#008300',
  '#4a3aa7', '#e34948', '#e87ba4', '#eb6834',
] as const

export const OTHER_COLOR = '#898781' // 9th+ series fold into "Other"

// Positioning tier → a meaningful ordered ramp (budget→bespoke).
export const TIER_COLOR: Record<string, string> = {
  budget: '#86b6ef',
  mid: '#3987e5',
  premium: '#4a3aa7',
  bespoke: '#330000', // oxblood — the house end of the market
}

export const CHART = {
  grid: '#e1e0d9',
  axis: '#c3c2b7',
  muted: '#898781',
  ink: '#0b0b0b',
  gold: '#C4AA70',
  oxblood: '#330000',
}

// Assign colors to categories in a stable order; overflow → Other.
export function assignCategoryColors(categories: string[]): Map<string, string> {
  const map = new Map<string, string>()
  categories.slice(0, CATEGORICAL.length).forEach((c, i) => map.set(c, CATEGORICAL[i]))
  categories.slice(CATEGORICAL.length).forEach((c) => map.set(c, OTHER_COLOR))
  return map
}
